import { z } from "zod";

/** What kind of thing an agent was doing at a step: drives the icon people see. */
export const ACTIVITY_KINDS = [
  "start",
  "read",
  "search",
  "think",
  "write",
  "check",
  "render",
  "decide",
  "done",
  "warn",
] as const;
export type ActivityKind = (typeof ACTIVITY_KINDS)[number];

export const activityStepSchema = z.object({
  at: z.string(),
  kind: z.enum(ACTIVITY_KINDS),
  text: z.string(),
});
export type ActivityStep = z.infer<typeof activityStepSchema>;

/** AgentRun.activity as stored, keeping only well-formed steps. */
export const readActivity = (raw: unknown): ActivityStep[] =>
  Array.isArray(raw)
    ? raw.flatMap((step) => {
        const parsed = activityStepSchema.safeParse(step);
        return parsed.success ? [parsed.data] : [];
      })
    : [];

/** How people see each AgentRun.agent id. */
const AGENT_NAMES: Record<string, string> = {
  researcher: "Researcher",
  director: "Director",
  writer: "Writer",
  designer: "Designer",
  critic: "Critic",
  art_director: "Art director",
  claims_check: "Claims checker",
  seo_strategist: "SEO strategist",
  icp_builder: "ICP builder",
  publisher: "Publisher",
  brand_designer: "Brand designer",
  trial: "Agent trial",
};

export const agentName = (id: string) =>
  AGENT_NAMES[id] ?? id.replace(/_/g, " ").replace(/^./, (first) => first.toUpperCase());
